import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addSpaces, getFirstAndLastWords, obfuscateEmail } from "../../utils";
import { fetchMyProfile } from "../../features/auth/authSlice";

function ProfileSummary() {
  const dispatch = useDispatch();
  const { userProfile } = useSelector((state) => state.auth);

  async function fetchMyUsersData() {
    await dispatch(fetchMyProfile());
  }

  useEffect(() => {
    fetchMyUsersData();
  }, []);

  const permissions = userProfile?.permissions ?? [];

  return (
    <div className="profile-summary-shell">
      <section className="profile-surface-card profile-overview-card">
        <div className="profile-overview-top">
          <div className="profile-avatar-badge">
            {getFirstAndLastWords(userProfile?.firstname)}
          </div>

          <div className="profile-overview-copy">
            <span className="profile-kicker">Identity</span>
            <h2>{userProfile?.firstname || "Profile"}</h2>
            <p>
              Review the core account identity, role, and contact details tied
              to this workspace.
            </p>

            <div className="profile-badges">
              {userProfile?.layer && (
                <span className="profile-badge profile-badge-layer">
                  {userProfile.layer}
                </span>
              )}
              {userProfile?.role && (
                <span className="profile-badge">{userProfile.role}</span>
              )}
            </div>
          </div>
        </div>

        <div className="profile-detail-grid">
          <div className="profile-detail-card">
            <span className="profile-detail-label">Full name</span>
            <strong>{userProfile?.firstname || "-"}</strong>
          </div>

          <div className="profile-detail-card">
            <span className="profile-detail-label">Email address</span>
            <strong>
              {userProfile?.email ? obfuscateEmail(userProfile.email) : "-"}
            </strong>
          </div>

          <div className="profile-detail-card">
            <span className="profile-detail-label">Phone number</span>
            <strong>
              {userProfile?.phoneNumber ? `+${addSpaces(userProfile.phoneNumber)}` : "-"}
            </strong>
          </div>

          <div className="profile-detail-card">
            <span className="profile-detail-label">Role</span>
            <strong>{userProfile?.role || "-"}</strong>
          </div>
        </div>
      </section>

      <section className="profile-surface-card">
        <div className="profile-section-head">
          <div>
            <span className="profile-kicker">Access</span>
            <h3>Permissions</h3>
            <p>Capabilities currently assigned to this user account.</p>
          </div>
        </div>

        {permissions.length > 0 ? (
          <div className="profile-permissions-grid">
            {permissions.map((permission, index) => (
              <div key={`${permission}-${index}`} className="profile-permission-chip">
                <span className="profile-permission-dot" />
                <span>{permission}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="profile-empty-state">No permissions assigned.</div>
        )}
      </section>
    </div>
  );
}

export default ProfileSummary;
